import type { RasterSourceSpecification } from 'maplibre-gl';

// CARTO basemap tiles require an API key (free tier: carto.com/basemaps/apikey).
// Without one, tiles render with an "API KEY REQUIRED" watermark. The key is
// public by nature — it ships in every tile URL — so it's a build-time Vite var.
const CARTO_KEY = import.meta.env.VITE_CARTO_KEY as string | undefined;

if (!CARTO_KEY) {
  console.warn('VITE_CARTO_KEY is not set — basemap tiles will be watermarked.');
}

const keyParam = CARTO_KEY ? `?key=${encodeURIComponent(CARTO_KEY)}` : '';

// Shared light basemap for the radar and wind maps.
export const lightBasemapSource: RasterSourceSpecification = {
  type: 'raster',
  tiles: ['a', 'b', 'c', 'd'].map(
    (s) => `https://${s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png${keyParam}`,
  ),
  tileSize: 256,
  attribution: '© OpenStreetMap contributors, © CARTO',
};
